import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Landing from "./pages/Landing";
import Accommodation from "./pages/Accommodation";
import Contact from "./pages/Contact";
import Friendbook from "./pages/Friendbook";
import Graduates from "./pages/Graduates";
import Imprint from "./pages/Imprint";
import News from "./pages/News";
import Policy from "./pages/Policy";
import Press from "./pages/Press";
import Work from "./pages/Work";
import LanguageProvider from "./languages/LanguageContext";
import NotFound from "./pages/NotFound";
import './sass/App.scss';
import ScrollToTop from "./components/ScrollToTop";
import About from "./pages/About";
import ScrollButton from "./components/ScrollButton";
import Archive from "./pages/Archive";
import Transform from "./pages/Transform";
import Videos from "./pages/Videos";

const App = () => {
    return (
        <Router>
            <ScrollToTop />
            <ScrollButton />
            <LanguageProvider>
                <Routes>
                    <Route path="/" element={<Landing/>} />
                    <Route path="/accommodation" element={<Accommodation/>} />
                    <Route path="/contact" element={<Contact/>} />
                    <Route path="/friendbook" element={<Friendbook/>} />
                    <Route path="/graduates" element={<Graduates/>} />
                    <Route path="/imprint" element={<Imprint/>} />
                    <Route path="/news" element={<News/>} />
                    <Route path="/policy" element={<Policy/>} />
                    <Route path="/press" element={<Press/>} />
                    <Route path="/work" element={<Work/>} />
                    <Route path="/about" element={<About/>} />
                    <Route path="/archive" element={<Archive />} />
                    <Route path="/videos" element={<Videos />} />

                    <Route path="/transform" element={<Transform />} />

                    {/* 404 PAGE */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </LanguageProvider>
        </Router>
    );
};

export default App;